const INTERLAY_COMPANY_LINK = 'https://www.interlay.io';
const INTERLAY_EMAIL_LINK = 'mailto:contact@interlay.io';
const INTERLAY_DISCORD_LINK = 'https://discord.gg/interlay';
const INTERLAY_GITHUB_LINK = 'https://github.com/interlay';
const INTERLAY_TWITTER_LINK = 'https://twitter.com/interlayHQ';
const INTERLAY_DOCS_LINK = 'https://docs.interlay.io';
const INTERLAY_CROWDLOAN_LINK = 'https://crowdloan.interlay.io';
const KINTSUGI_CROWDLOAN_LINK = 'https://claim-kint.interlay.io';
const INTERLAY_TERMS_AND_CONDITIONS_LINK =
  'https://github.com/interlay/terms/blob/master/interlay-dapp-terms-of-use.pdf';
const KINTSUGI_TERMS_AND_CONDITIONS_LINK =
  'https://github.com/interlay/terms/blob/master/kintsugi-dapp-terms-of-use.pdf';
const INTERLAY_USE_WRAPPED_CURRENCY_LINK = 'https://docs.interlay.io/#/interlay/earn-with-ibtc';
const INTERLAY_GET_ASSETS_LINK = 'https://docs.interlay.io/#/guides/assets';
const KINTSUGI_USE_WRAPPED_CURRENCY_LINK = 'https://docs.interlay.io/#/kintsugi/Earn-With-kBTC';
const INTERLAY_GOVERNANCE_LINK = 'https://interlay.subsquare.io/';
const KINTSUGI_GOVERNANCE_LINK = 'https://kintsugi.subsquare.io';
const INTERLAY_SUBSCAN_LINK = 'https://interlay.subscan.io';
const KINTSUGI_SUBSCAN_LINK = 'https://kintsugi.subscan.io';
const INTERLAY_VAULT_DOCS_LINK = 'https://docs.interlay.io/#/vault/overview';
const INTERLAY_DOS_AND_DONTS_DOCS_LINK = 'https://docs.interlay.io/#/vault/installation?id=dos-and-donts';
const INTERLAY_WHITEPAPPER = 'https://gateway.pinata.cloud/ipfs/QmWp62gdLssFpAoG2JqK8sy3m3rTRUa8LyzoSY8ZFisYNB';

const BANXA_LINK = 'http://checkout.banxa.com/';

const GEOBLOCK_API_ENDPOINT = '/check_access';
const GEOBLOCK_REDIRECTION_LINK = 'https://www.interlay.io/geoblock';

const FORMS_STRATEGIES_LINK = 'https://forms.gle/Ue7NQ81j2u5oNDey6';

const BIFROST_SWAP_LINK = 'https://bifrost.app/swap';

export {
  BANXA_LINK,
  BIFROST_SWAP_LINK,
  FORMS_STRATEGIES_LINK,
  GEOBLOCK_API_ENDPOINT,
  GEOBLOCK_REDIRECTION_LINK,
  INTERLAY_COMPANY_LINK,
  INTERLAY_CROWDLOAN_LINK,
  INTERLAY_DISCORD_LINK,
  INTERLAY_DOCS_LINK,
  INTERLAY_DOS_AND_DONTS_DOCS_LINK,
  INTERLAY_EMAIL_LINK,
  INTERLAY_GET_ASSETS_LINK,
  INTERLAY_GITHUB_LINK,
  INTERLAY_GOVERNANCE_LINK,
  INTERLAY_SUBSCAN_LINK,
  INTERLAY_TERMS_AND_CONDITIONS_LINK,
  INTERLAY_TWITTER_LINK,
  INTERLAY_USE_WRAPPED_CURRENCY_LINK,
  INTERLAY_VAULT_DOCS_LINK,
  INTERLAY_WHITEPAPPER,
  KINTSUGI_CROWDLOAN_LINK,
  KINTSUGI_GOVERNANCE_LINK,
  KINTSUGI_SUBSCAN_LINK,
  KINTSUGI_TERMS_AND_CONDITIONS_LINK,
  KINTSUGI_USE_WRAPPED_CURRENCY_LINK
};
